import api from './api';
import { User } from '../types';

export interface CreateUserData {
  name: string;
  phone: string;
  email?: string;
  password: string;
  role: 'org_admin' | 'manager' | 'executive';
  status?: 'active' | 'inactive';
}

export interface UpdateUserData {
  name?: string;
  phone?: string;
  email?: string;
  password?: string;
  role?: 'org_admin' | 'manager' | 'executive';
  status?: 'active' | 'inactive';
}

export interface UserFilters {
  search?: string;
  role?: 'org_admin' | 'manager' | 'executive';
  status?: 'active' | 'inactive';
}

export const userService = {
  getAll: async (filters?: UserFilters): Promise<User[]> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }
    const queryString = params.toString();
    const url = queryString ? `/api/users?${queryString}` : '/api/users';
    const response = await api.get(url);
    return response.data.data || [];
  },

  getById: async (id: number): Promise<User> => {
    const response = await api.get(`/api/users/${id}`);
    return response.data.data;
  },

  create: async (userData: CreateUserData): Promise<User> => {
    const response = await api.post('/api/users', userData);
    return response.data.data;
  },

  update: async (id: number, userData: UpdateUserData): Promise<User> => {
    const response = await api.put(`/api/users/${id}`, userData);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/users/${id}`);
  },

  getAssignedBrands: async (userId: number): Promise<number[]> => {
    const response = await api.get(`/api/users/${userId}/brands`);
    return response.data.data ?? [];
  },

  setAssignedBrands: async (userId: number, brandIds: number[]): Promise<void> => {
    await api.put(`/api/users/${userId}/brands`, { brand_ids: brandIds });
  },

  // Get users for dropdowns (minimal data, accessible to all authenticated users)
  getDropdownList: async (filters?: { role?: string; status?: string }): Promise<User[]> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }
    const queryString = params.toString();
    const url = queryString ? `/api/users/dropdown?${queryString}` : '/api/users/dropdown';
    const response = await api.get(url);
    return response.data.data || [];
  },
};

